import React from 'react';
import { BudgetInput } from '../../../components/shared/BudgetInput';
import BudgetStepWrapper from './BudgetStepWrapper';

// --- Budget Step 4: Savings ---
const BudgetStep4 = ({ savings, setSavings, handleChange, onNext, onPrev }) => (
  <BudgetStepWrapper title="Finally, Pay Yourself First" description="Set a monthly goal for your savings." onNext={onNext} onPrev={onPrev}>
    <BudgetInput label="Emergency Fund" id="emergency" value={savings.emergency} onChange={v => handleChange(setSavings, 'emergency', v)} />
    <BudgetInput label="Investing/Retirement (401k, IRA)" id="investing" value={savings.investing} onChange={v => handleChange(setSavings, 'investing', v)} />
    <BudgetInput label="Other Big Savings (Vacation, New Car, etc.)" id="other" value={savings.other} onChange={v => handleChange(setSavings, 'other', v)} />
  </BudgetStepWrapper>
);

export default BudgetStep4;